import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=A%20magnificent%20ancient%20Chinese%20palace%20at%20golden%20hour%20with%20flowing%20silk%20curtains%20and%20cherry%20blossom%20trees%20in%20warm%20coral%20pink%20and%20golden%20amber%20tones%20cinematic%20epic%20composition%20with%20soft%20atmospheric%20haze%20and%20elegant%20traditional%20aesthetic&width=1200&height=500&seq=carousel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20dreamy%20summer%20school%20campus%20with%20cherry%20blossoms%20young%20students%20in%20uniforms%20walking%20under%20warm%20sunlight%20in%20soft%20peach%20and%20cream%20tones%20cinematic%20youth%20drama%20aesthetic%20with%20nostalgic%20film-like%20color%20grading&width=1200&height=500&seq=carousel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20elegant%20classic%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20Oscar-style%20statues%20on%20display%20in%20warm%20coral%20and%20golden%20lighting%20vintage%20Hollywood%20glamour%20aesthetic%20with%20cinematic%20atmosphere&width=1200&height=500&seq=carousel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20vibrant%20Southeast%20Asian%20floating%20market%20at%20sunset%20with%20colorful%20boats%20tropical%20fruits%20and%20golden%20temple%20spires%20in%20the%20background%20in%20warm%20amber%20and%20coral%20tones%20cinematic%20travel%20photography%20style&width=1200&height=500&seq=carousel-04&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-star-line"></i>
            <span>焦点推荐</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            焦点推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            糖心视频精心策划的焦点专题，优质内容一站呈现
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {carouselItems.map((item, idx) => (
            <a
              key={item.id}
              href={item.url}
              className="group relative rounded-2xl overflow-hidden bg-background-100 hover:ring-2 hover:ring-accent-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2.4/1] overflow-hidden">
                <img
                  src={carouselImages[idx]}
                  alt={`${item.title} - 糖心视频焦点推荐`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="text-xs px-3 py-1 rounded-full bg-accent-500 text-white font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-base md:text-lg font-semibold text-white mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-white/80 line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}